// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-avenue -> z-modular-avenue -> flatz-four-eight-zero
// Generated: 2026-11-03T18:40:01.195Z
// Counts: 6 design, 77 content, 58 slot group, 3 collection binding, 8 section, 2 style

export const designOverrides = {
  "design._site.font.heading": {
    "cssVariable": "--vibe-font-heading",
    "overrideType": "VALUE",
    "value": "'Nunito', sans-serif",
    "mappedField": null
  },
  "design._site.color.hyperlink": {
    "cssVariable": "--vibe-color-hyperlink",
    "overrideType": "FIELD_MAPPING",
    "value": null,
    "mappedField": "property_color_5"
  },
  "design._site.color.linkUnderline": {
    "cssVariable": "--vibe-color-link-underline",
    "overrideType": "VALUE",
    "value": "underline",
    "mappedField": null
  },
  "design._site.font.accent": {
    "cssVariable": "--vibe-font-accent",
    "overrideType": "VALUE",
    "value": "'Work Sans', sans-serif",
    "mappedField": null
  },
  "design._site.font.body": {
    "cssVariable": "--vibe-font-body",
    "overrideType": "VALUE",
    "value": "'Work Sans', sans-serif",
    "mappedField": null
  },
  "design._site.font.mono": {
    "cssVariable": "--vibe-font-mono",
    "overrideType": "VALUE",
    "value": "'Work Sans', sans-serif",
    "mappedField": null
  }
};

export const contentOverrides = {
  "amenitieslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_color_4"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form.bedroom_list_type": {
    "overrideType": "VALUE",
    "customValue": "derived",
    "generatedValue": null,
    "mappedField": null
  },
  "fees.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "footer.address": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_full_address"
  },
  "footer.copyright": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_copyright"
  },
  "gallery.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "gallery.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.subtitle": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_interactivemap_blurb"
  },
  "pagehero.title": {
    "overrideType": "VALUE",
    "customValue": "virtual tour",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_name"
  },
  "virtual-tour.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "accessibility-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Accessibility</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Features Made for You</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Amenities</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Start Your Rental Application Online Today</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Apply Now</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "better-built-living-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>What Life at <span data-type=\"field-token\" data-field=\"property_name\"></span> Is Like for You</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "better-built-living-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Better-Built Living</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Questions? Our Leasing Team Is Ready to Help</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Contact Us</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "ctasection.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore What All <span data-type=\"field-token\" data-field=\"property_name\"></span> Has To Offer</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "faq-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Answers About Leasing, Amenities, Pets &amp; More</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "faq-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>FAQ</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1><span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> Apartments</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Floor Plans</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Community &amp; Apartment Photos</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Gallery</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Studio to Three Bedrooms. Room for However You're Living.</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Welcome to <span data-type=\"field-token\" data-field=\"property_name\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "_template:hyperlocal::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Experience luxury living in San Tan Valley with FLATZ 480. Enjoy the convenience of an in-home washer and dryer in our upscale apartments.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "_template:hyperlocal::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Luxury Apartment with In-Home Washer &amp; Dryer</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Explore <span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Interactive Map</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactivemapsection.map_block": {
    "overrideType": "VALUE",
    "customValue": "engrain-sitemap",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Stake Your Claim in the State’s Newest Town</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Neighborhood</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Breed Guidelines, Fees &amp; Pet-Friendly Amenities</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Pet Policy</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Privacy Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_rentgrata_token"
  },
  "resident-access-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pay Rent, Submit Maintenance Requests &amp; More</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Resident Access</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Hear From Residents Who Call <span data-type=\"field-token\" data-field=\"property_name\"></span> Home</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Reviews</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewscallout.title": {
    "overrideType": "VALUE",
    "customValue": "<h3>What Residents Say About <span data-type=\"field-token\" data-field=\"property_name\"></span></h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Book an In-Person or Virtual Apartment Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Schedule A Tour</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduletourform.form.disable_self_guided_tour": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduletourform.form.self_guided_tour_link": {
    "overrideType": "VALUE",
    "customValue": "custom_pineapple_selfguided_tours",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Sitemap</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>We Received Your Message — Thanks for Reaching Out</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Thank You</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Walk Through Apartment Homes From Anywhere</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Virtual Tours</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Map your next move. Explore available apartments at <span data-type=\"field-token\" data-field=\"property_name\"></span>. Use the interactive map to browse the community, click a building to see which apartments are available, and find the home that fits you.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "lifestylecommunity.intro": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>San Tan Valley sits where the East Valley's suburbs meet open Sonoran Desert, drawing young families, remote workers, Gateway-area commuters, and trail lovers who want room to breathe without losing touch with Queen Creek, Gilbert, and Chandler. Here's how six kinds of everyday life play out around FLATZ 480.</p>",
    "mappedField": null
  },
  "lifestylecommunity.item1_body": {
    "overrideType": "VALUE",
    "customValue": "<ul><li><p>Many residents work in the energy industry, including engineers, geologists, rig workers, and executives.</p></li><li><p>These families often experience rapid booms and occasional busts, depending on oil prices.</p></li><li><p>Neighborhoods like Grassland Estates and parts of north Midland cater to professionals looking for newer, family-oriented homes.</p></li></ul>",
    "generatedValue": "<ul><li>San Tan Mountain Regional Park protects more than 10,000 acres of desert with hiking, biking, and equestrian trails</li><li>The park's visitor center has wildlife exhibits, which makes it an easy first stop before a sunrise hike or a sunset ride</li><li>Saguaro-dotted mountain views frame daily life, and you can come home to the <a href=\"/amenities\">pool and hot tub</a> after a dusty trail day</li></ul>",
    "mappedField": null
  },
  "lifestylecommunity.item1_title": {
    "overrideType": "VALUE",
    "customValue": "<p>Oil & Gas Professionals and Families</p>",
    "generatedValue": "<p>Desert Trails at Your Doorstep</p>",
    "mappedField": null
  },
  "lifestylecommunity.item2_body": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<ul><li>Neighborhood schools nearby include Combs High School, J.O. Combs Middle School, Combs Traditional Academy, and Ranch and Simonton Elementary</li><li>Skyline Ranch Community Park, Desert Rose Park, and Paisley Park offer playgrounds and open green space close to home</li><li>Weekend fun is close by too, with Pecan Lake Entertainment's go-karts and ropes course and FatCats Queen Creek's bowling and theaters</li></ul>",
    "mappedField": null
  },
  "lifestylecommunity.item2_title": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Room to Grow for Families</p>",
    "mappedField": null
  },
  "lifestylecommunity.item3_body": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<ul><li>Schnepf Farms has seasonal U-pick produce plus festivals throughout the year</li><li>Queen Creek Olive Mill makes its own olive oil and runs mill tours, a gourmet market, and a café</li><li>The Pork Shop has been butchering and smoking meats in-house since 1979, which makes it a local go-to for weekend grilling</li></ul>",
    "mappedField": null
  },
  "lifestylecommunity.item3_title": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Farm-to-Table Agritourism Country</p>",
    "mappedField": null
  },
  "lifestylecommunity.item4_body": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<ul><li>Major employers within driving distance include Intel's Ocotillo Campus in Chandler and the Mesa Gateway Airport area</li><li>Students and aviation professionals can reach ASU Polytechnic, Embry-Riddle's Phoenix-Mesa campus, and Central Arizona College's San Tan Campus</li><li>Mesa Gateway Airport is close by for flights, so getting away is easy. See the <a href=\"/neighborhood\">neighborhood guide</a> for more</li></ul>",
    "mappedField": null
  },
  "lifestylecommunity.item4_title": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>East Valley Commuter Access</p>",
    "mappedField": null
  },
  "lifestylecommunity.item5_body": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<ul><li>On-site CoWork Studio, private conference room, and high-speed bulk Wi-Fi turn home into a capable office</li><li>Biscuits Cafe offers free WiFi with breakfast or lunch for a change of scenery on workdays</li><li>Skipping the daily commute leaves time for midday workouts at Mountainside Fitness San Tan or Soul Sisters Yoga</li></ul>",
    "mappedField": null
  },
  "lifestylecommunity.item5_title": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Remote Work, Desert Pace</p>",
    "mappedField": null
  },
  "lifestylecommunity.item6_body": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<ul><li>Sonoran-style favorites at Someburros and Moreno's Mexican Grill, cornbread waffles at Maddie Jo's BBQ, and seafood boils at Angry Crab Shack</li><li>Fry's Marketplace, Safeway, and Walmart Supercenter handle groceries, with Marshalls, HomeGoods, and Ulta Beauty nearby</li><li>SanTan Village and Harkins Theatres are a short drive away for a bigger night out, and Banner Ironwood Medical Center provides care close to home</li></ul>",
    "mappedField": null
  },
  "lifestylecommunity.item6_title": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Easygoing Local Eats and Errands</p>",
    "mappedField": null
  },
  "lifestylecommunity.title": {
    "overrideType": "VALUE",
    "customValue": "<p>San Tan Valley, Arizona is known as the heart of the:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>San Tan Valley didn't have its own name until residents voted on one in 2009. Last year, they voted again and made it official, becoming the largest town to ever incorporate in Arizona history. That's the STV way: people arrive, decide what they want, and build it. Arrive early enough, and you're not just moving in, you're part of how it turns out. Weekdays are easy. A stop at Fry's on the way home, Banner Ironwood minutes away instead of a drive across town, the LG Energy Solution plant hiring in waves just up the road. Weekends look different. Ironwood Crossing's trails for whoever's up early enough. Yogi's Grill or Moreno's when nobody feels like cooking. Slick City or go-karts at Pecan Lake if the kids are in charge for the day. When you want a bigger night out, Harkins and the Queen Creek Olive Mill aren't far. Step outside and the San Tan Mountains are right there, under the kind of dark sky you forget exists until you're here. This is a great place to build from, wherever you're headed next. FLATZ 480 is new. San Tan Valley is new. Time to make it yours.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.pre_title": {
    "overrideType": "VALUE",
    "customValue": "More Space, Less Commute, That’s Easy Math",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduletourform.form.use_leads_tour_times": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "footer.design_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/company/5767906449162415/019d6d9d-49a5-7587-b84e-e2aedab919be.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Repli Logo"
      }
    }
  },
  "footer.powered_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/company/5767906449162415/019d6d9d-fa1c-74bf-a89d-68fd979db7af.webp"
      }
    }
  },
  "header.schedule_tour_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/schedule-a-tour"
      }
    }
  },
  "pagehero.bg_image": {
    "sourceIndex": 5,
    "fieldOverrides": null
  },
  "flexiblelivingprograms.card1_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a15a4a-d878-773a-a930-cec812802db9.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "FLEX logo"
      }
    }
  },
  "flexiblelivingprograms.card2_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a15a42-1fb9-70ab-b6d9-28b9225354db.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Obligo logo"
      }
    }
  },
  "flexiblelivingprograms.card3_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a15a46-8bbe-70aa-b774-4fa553335ff2.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Beagle logo with a dog wearing a tie inside an orange square."
      }
    }
  },
  "flexiblelivingprograms.card4_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a15a46-8b62-7369-a1e1-504e1b5e29e7.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "RentCafe logo"
      }
    }
  },
  "flexiblelivingprograms.card5_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a15a4a-247d-7396-b23b-7a6eeab770d3.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "The Guarantors logo."
      }
    }
  },
  "flexiblelivingprograms.card6_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a15a46-8c3e-7295-89e2-87ef61ff7baa.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Pineapple logo"
      }
    }
  },
  "lifestylefeatures.card1_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/better-built-living"
      }
    }
  },
  "lifestylefeatures.card3_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/flexible-living-programs"
      }
    }
  },
  "lifestylefeatures.card4_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/rewards-programs"
      }
    }
  },
  "rewardsprograms.card1_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a155bb-891e-7344-b667-4883368214eb.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Diverse group of friends toasting with drinks on a sunny rooftop gathering."
      }
    }
  },
  "rewardsprograms.card3_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a155bb-317d-770d-986a-94323614314e.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A joyful couple enjoys a morning coffee and healthy breakfast of grapefruit in their cozy apartment."
      }
    }
  },
  "amenities-hero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cb-ec43-73c1-87a7-28cecd1f4d47.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "FLATZ 480 resort-style pool with lounge chairs, red Adirondack chairs, and shaded pergolas"
      }
    }
  },
  "amenitieslist.apartment_photo1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a15635-7524-759a-b52d-ffede6b41cf9.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Kitchen with quartz countertops, dark wood cabinetry, and stainless steel appliances"
      }
    }
  },
  "amenitieslist.apartment_photo2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cb-e045-70e8-bcfe-44b971cf71de.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Open-concept living room with grey sectional flowing into the kitchen and breakfast bar"
      }
    }
  },
  "amenitieslist.apartment_photo3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cb-e116-74fe-8c56-ca12fa102205.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Bedroom with king-size bed, walk-in closet, and en-suite bathroom"
      }
    }
  },
  "amenitieslist.apartment_photo4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cb-e8cd-73cf-b1bc-6335f775c91f.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Private balcony with potted plant and a view back into the living room"
      }
    }
  },
  "amenitieslist.apartment_photo5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cb-e1b7-74d8-b871-ea016e873fd5.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Living room with sectional sofa and access to a private balcony"
      }
    }
  },
  "amenitieslist.apartment_photo6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cb-f542-7449-8b4d-19d23a8567c2.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Living area with flat-screen TV, wood slab coffee table, and blue armchair"
      }
    }
  },
  "amenitieslist.community_photo1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cc-00d5-7482-86fc-8396685def9a.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "FLATZ 480 pool deck with lounge chairs, umbrella-shaded tables, and a fire pit"
      }
    }
  },
  "amenitieslist.community_photo2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cb-f753-77ba-a000-6ef261e7b5e4.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Multi-sport simulator room at FLATZ 480 with golf clubs and putting green"
      }
    }
  },
  "amenitieslist.community_photo3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cb-f506-7638-a8c6-f3dd897fcb09.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Resident lounge with high-top tables and stools overlooking the outdoor patio"
      }
    }
  },
  "amenitieslist.community_photo4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167811/01a16522-b5d6-70ab-a182-ba2f87900412.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of FLATZ 480 pools, pickleball courts, and outdoor seating areas"
      }
    }
  },
  "betterbuiltcta.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cb-e1b7-74d8-b871-ea016e873fd5.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "FLATZ 480 living room with a sectional sofa, modern decor, and an open door to a private balcony"
      }
    }
  },
  "betterbuiltfeatures.row1_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a15635-7524-759a-b52d-ffede6b41cf9.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "FLATZ 480 kitchen with quartz countertops, dark wood cabinets, and stainless steel appliances"
      }
    }
  },
  "betterbuiltfeatures.row2_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cb-e8c0-72fe-97ae-2fe3a5aa828e.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Bright FLATZ 480 bedroom with a king bed, nightstands, and a large window letting in daylight"
      }
    }
  },
  "contact-hero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cb-ec43-73c1-87a7-28cecd1f4d47.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "FLATZ 480 resort-style pool with lounge chairs, red Adirondack chairs, and shaded pergolas"
      }
    }
  },
  "ctasection.card1_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a13715-9790-7066-a75d-c9f3d64c642b.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Man with glasses and beard working on a laptop at a table."
      }
    }
  },
  "ctasection.card2_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a15635-7524-759a-b52d-ffede6b41cf9.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern kitchen with dark wood cabinets, stainless steel appliances, and quartz countertops."
      }
    }
  },
  "ctasection.card3_image": {
    "sourceIndex": 0,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a13715-7b0c-701d-8189-767ac72ba7d8.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A group of friends enjoys a meal of tacos together outdoors."
      }
    }
  },
  "ctasection.card4_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cc-00d5-7482-86fc-8396685def9a.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Outdoor swimming pool area with lounge chairs, tables, umbrellas, and a fire pit."
      }
    }
  },
  "floor-plans-hero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cb-e045-70e8-bcfe-44b971cf71de.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern living room with a grey sectional sofa, coffee tables, and an open-concept kitchen."
      }
    }
  },
  "floorplanslist.card_image_0": {
    "sourceIndex": 7,
    "fieldOverrides": null
  },
  "floorplanslist.card_image_1": {
    "sourceIndex": 5,
    "fieldOverrides": null
  },
  "floorplanslist.card_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cb-e8c0-72fe-97ae-2fe3a5aa828e.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Bedroom with a king-size bed, nightstands, and a window."
      }
    }
  },
  "floorplanslist.card_image_3": {
    "sourceIndex": 9,
    "fieldOverrides": null
  },
  "floorplanslist.card_image_4": {
    "sourceIndex": 13,
    "fieldOverrides": null
  },
  "footer.logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_primary_logo"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_primary_logo_media.alt_text"
      }
    }
  },
  "gallery-hero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cb-ec43-73c1-87a7-28cecd1f4d47.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "FLATZ 480 resort-style pool with lounge chairs, red Adirondack chairs, and shaded pergolas"
      }
    }
  },
  "lifestylecta.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cb-ec43-73c1-87a7-28cecd1f4d47.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Outdoor swimming pool area with lounge chairs, red Adirondack chairs, and pergolas."
      }
    }
  },
  "lifestylefeatures.card1_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cb-e8cd-73cf-b1bc-6335f775c91f.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior of FLATZ 480 seen from a private apartment balcony with a potted plant"
      }
    }
  },
  "lifestylefeatures.card3_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cb-e1b7-74d8-b871-ea016e873fd5.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Living room with a sectional sofa and a balcony view."
      }
    }
  },
  "lifestylefeatures.card4_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cb-f506-7638-a8c6-f3dd897fcb09.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern communal lounge area with high-top tables and stools, overlooking an outdoor patio with umbrellas and seating."
      }
    }
  },
  "lifestylehero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cc-00d5-7482-86fc-8396685def9a.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Outdoor swimming pool area with lounge chairs, tables, umbrellas, and a fire pit."
      }
    }
  },
  "neighborhood-hero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cd-7355-73bc-b2ac-6daf14a79d17.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Desert trails and Sonoran landscape at San Tan Mountain Regional Park near FLATZ 480 in San Tan Valley"
      }
    }
  },
  "propertyoverview.feature_image_1": {
    "sourceIndex": 3,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a1371e-8139-76a9-b915-ef452bd75481.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Exterior view of a modern apartment building with colorful panels and balconies under a clear blue sky."
      }
    }
  },
  "propertyoverview.feature_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cb-ec43-73c1-87a7-28cecd1f4d47.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Outdoor swimming pool area with lounge chairs, red Adirondack chairs, and pergolas."
      }
    }
  },
  "propertyoverview.feature_image_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cb-f506-7638-a8c6-f3dd897fcb09.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern communal lounge area with high-top tables and stools, overlooking an outdoor patio with umbrellas and seating."
      }
    }
  },
  "propertyoverview.feature_image_4": {
    "sourceIndex": 1,
    "fieldOverrides": null
  },
  "teamcta.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cb-f506-7638-a8c6-f3dd897fcb09.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern communal lounge area with high-top tables and stools, overlooking an outdoor patio with umbrellas and seating."
      }
    }
  },
  "teammembers.member1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "photo": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a16046-24ca-7108-8ea0-7f0db6636326.webp"
      },
      "photo_alt": {
        "type": "VALUE",
        "customValue": "Professional headshot of a woman in a grey blazer."
      },
      "name": {
        "type": "VALUE",
        "customValue": "Marissa M."
      },
      "title": {
        "type": "VALUE",
        "customValue": "Community Manager"
      },
      "bio": {
        "type": "VALUE",
        "customValue": "<p>Marissa brings a decade of experience in the multifamily industry. She truly enjoys creating welcoming communities where residents feel comfortable, connected, and proud to call home. She loves getting to know our residents and helping make their experience at FLATZ 480 a great one from the moment they walk through our door! Outside of work, she enjoys spending time with her family and making memories together. One of her favorite amenities at FLATZ 480 is the community garden! It’s such a great space to relax, enjoy the outdoors, and connect with neighbors!</p>"
      }
    }
  },
  "teammembers.member2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Fernando A."
      },
      "photo": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a16046-1835-760f-b163-d8edd39b59ac.webp"
      },
      "photo_alt": {
        "type": "VALUE",
        "customValue": "Smiling man in a red polo shirt"
      },
      "title": {
        "type": "VALUE",
        "customValue": "Maintenance Manager"
      },
      "bio": {
        "type": "VALUE",
        "customValue": "<p>Fernando brings 15 years of experience in the maintenance industry, with a strong background in property maintenance, troubleshooting, preventative maintenance, and team leadership. He takes pride in maintaining high standards, finding solutions, and creating the best experiences for residents. Fernando believes that good character, attention to detail, teamwork, and taking ownership of every task are essential to providing an exceptional living experience. Outside of work, he enjoys spending time with his wife and son, being outdoors, and making memories with his family. One of his favorite amenities at FLATZ 480 is the Multi-Sport Simulator because it offers residents a fun and unique way to stay active, enjoy some friendly competition, and connect with friends and neighbors.</p>"
      }
    }
  },
  "teammembers.member3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "visible": {
        "type": "VALUE",
        "customValue": ""
      }
    }
  },
  "virtual-tour-hero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cb-e045-70e8-bcfe-44b971cf71de.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Open-concept apartment living room with a grey sectional sofa that opens into a modern kitchen with a breakfast bar"
      }
    }
  }
};

export const collectionBindingOverrides = {
  "amenitieslist.apartmentPhotos": {
    "limit": 12,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "amenitieslist.communityPhotos": {
    "limit": 12,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "gallery.images": {
    "limit": null,
    "hiddenIds": [
      "custom_2e978e4e-f058-4d94-a797-e3b7f9ad84c8"
    ],
    "orderedIds": [
      "custom_c1bccc7c-1845-4cae-beb2-737ed5e1d5bd",
      "custom_72bec93a-7f74-40e5-a320-244bf764bd7e",
      "custom_49be800a-2857-4965-adb2-4ebf877dc007",
      "custom_b262cfea-e74a-4c0f-84d6-1137948ef6b8",
      "custom_8a053186-8d4b-4f88-b35b-f499c1c63d4a",
      "custom_9a6fba68-7e05-4de7-8a67-5d634357b978",
      "custom_f8631f96-b728-471c-b014-e18d8fbe7020",
      "custom_ed8371bf-02c8-4ef1-9f5c-5dc656ab7b2e",
      "custom_eda15867-fa9c-4213-a71a-277255cf87cd",
      "custom_fd5dd00d-b922-4056-8aa0-bf969e4399ab",
      "custom_183fce0c-4682-462d-9e60-7053b9141cc2",
      "custom_2e978e4e-f058-4d94-a797-e3b7f9ad84c8",
      "custom_88e700d5-37ef-4075-bc38-9a8810f52e6b",
      "custom_81c6e293-da00-4763-a8f0-7f75ca7d5cfd"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "funnel-fenix-chatbot",
      "blockId": "funnel-fenix-chatbot",
      "position": 0
    },
    {
      "sectionId": "rentgrata-widget",
      "blockId": "rentgrata-widget",
      "position": 0
    }
  ],
  "floor-plans": [
    {
      "sectionId": "apartment-sync",
      "blockId": "apartment-sync",
      "position": 10
    }
  ]
};

export const styleOverrides = {
  "_section.block:apartment-sync": {
    "properties": {
      "paddingRight": "15px",
      "paddingLeft": "15px",
      "backgroundColor": "#ffffff"
    }
  },
  "_section.block:engrain-sitemap": {
    "properties": {
      "paddingTop": "25px",
      "paddingRight": "100px",
      "paddingBottom": "100px",
      "paddingLeft": "100px",
      "backgroundColor": "#ffffff"
    }
  }
};
